var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo-link",attrs:{"href":"https://www.uptick.network/","target":"_blank","rel":"noopener noreferrer"}},[_c('img',_vm._b({staticClass:"logo",attrs:{"alt":"Uptick Network logo","src":require("@/assets/Uptick Network logo.svg"),"height":_vm.height,"width":`${_vm.simple ? _vm.height : 'auto'}`}},'img',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }